import { useSnackbar } from "notistack";

const useSnackbarNotification = () => {
    const { enqueueSnackbar } = useSnackbar();

    const showSuccess = (message) => {
        enqueueSnackbar(message, {
            variant: "success",
            anchorOrigin: {
                vertical: "top",
                horizontal: "center",
            },
        });
    };

    const showError = (message) => {
        enqueueSnackbar(message, {
            variant: "error",
            anchorOrigin: {
                vertical: "top",
                horizontal: "center",
            },
        });
    };

    return { showSuccess, showError };
};

export default useSnackbarNotification;
